import Curve from './Curve.js';
/**
 * Base class for Point (affine coordinates) and JacobianPoint classes,
 * defining their curve and type.
 */
export default class BasePoint {
    curve;
    type;
    precomputed;
    constructor(type) {
        this.curve = new Curve(); // Always initialized, so never null
        this.type = type;
        this.precomputed = null;
    }
}
//# sourceMappingURL=BasePoint.js.map